var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.similarProducts && _vm.similarProducts.length)?_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-0"},[_c('h4',[_vm._v("Customers also purchased")]),_c('ProductSwiper',{attrs:{"products":_vm.favouriteProducts,"showAddCart":false,"internalApi":true}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }